Backbone.Radio.channel('views').reply('form-comments',function(options){
	var opts = {
		
	}
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-comments").html())
		,events:{
			'click #onAirThanks input[type=radio]':function(e){
				if( this.$el.find(e.currentTarget).val() == '1' ){ this.$el.find('#thankYouText').removeClass('d-none') }else{ this.$el.find('#thankYouText').addClass('d-none'); }
				return;
			}
			,'keyup #thankYouText input':function(e){
				var text = this.$el.find(e.currentTarget).val();
				var maxLength = 250;
				if(text.length >= maxLength){
					text = text.slice(0,maxLength) //assign to a var so the length check later is correct
					this.$el.find(e.currentTarget).val( text )
				}
				this.$el.find('#charsLeftThankYou').html(+maxLength - text.length)
			}

		}
		,onAttach:function(){
			if(Backbone.settings.flags.pledgeDrive){
				this.$el.find('#onAirThanks').removeClass('d-none')
			}
		}
	})
	
	
	return new (view)();
});